import { Text } from '@billy/design-system'
import React from 'react'

import * as Styled from './styles'

export type SelectMenuItemProps = {
  id: string
  active?: boolean
  children: React.ReactNode
  onSelect: (id: string) => void
}

export const SelectMenuItem = React.forwardRef<HTMLDivElement, SelectMenuItemProps>(
  ({ id, active, onSelect, children }, ref) => (
    <Styled.SelectMenuItem ref={ref} key={id} onClick={() => onSelect(id)} active={active}>
      <Text weight="medium">{children}</Text>
    </Styled.SelectMenuItem>
  ),
)
